import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getPortalAccess } from '@dss/api-client'
import { useAccessToken, useDistributionPrincipal } from '@dss/auth'
import { api } from '../../lib/api'

/** Claim идентифицирует кеш, но не выдаёт права: все пары приходят из DB policy. */
export function useCartIdentity() {
  const principal = useDistributionPrincipal()
  return `${principal?.distributorId ?? ''}:${principal?.userId ?? ''}`
}
export function usePortalCartContext() {
  const token = useAccessToken()
  const principal = useDistributionPrincipal()
  const identity = useCartIdentity()
  const client = useQueryClient()
  const access = useQuery({
    queryKey: ['portal-access', identity, principal?.authorizationVersion ?? 0,
      [...new Set(principal?.roles ?? [])].sort(), [...new Set(principal?.permissions ?? [])].sort()],
    queryFn: ({ signal }) => getPortalAccess(api, token!, signal),
    enabled: Boolean(token), retry: false, staleTime: 0,
    refetchOnWindowFocus: 'always',
  })
  const selection = useQuery<number | null>({
    queryKey: ['portal-cart-point', identity], queryFn: () => null,
    initialData: () => {
      try {
        const id = Number(sessionStorage.getItem(`portal-cart-point:${identity}`))
        return Number.isSafeInteger(id) && id > 0 ? id : null
      } catch { return null }
    }, enabled: false,
  })
  const lock = useQuery({ queryKey: ['portal-cart-lock', identity], queryFn: () => false,
    initialData: false, enabled: false })
  const data = access.isError ? undefined : access.data
  const pointId = data?.pairs.some(pair => pair.tradepointId === selection.data)
    ? selection.data ?? null : null
  let pendingConfirmation = false
  try {
    pendingConfirmation = pointId != null
      && sessionStorage.getItem(`portal-checkout:${identity}:${pointId}`) != null
  } catch { /* Текущий runtime-lock остаётся в QueryClient. */ }
  const locked = lock.data || pendingConfirmation
  return {
    ...access, data, pointId, locked,
    // Только ключ локального ввода. Не подтверждает доступ к выбранной точке.
    selectedPointId: selection.data ?? null,
    selectPoint: (id: number | null) => {
      if (locked) return
      client.setQueryData(['portal-cart-point', identity], id)
      try {
        if (id == null) sessionStorage.removeItem(`portal-cart-point:${identity}`)
        else sessionStorage.setItem(`portal-cart-point:${identity}`, String(id))
      } catch { /* Выбор остаётся в памяти текущего сеанса. */ }
    },
  }
}
